module.exports = __webpack_public_path__ + "static/media/Slide59.de637c6c.JPG";